export default "__VITE_ASSET__3e7a1a22__"